import type { ChakraProps } from "@chakra-ui/react";
import type { MenuExtendedProps } from "config/menus/menus.d";
import MenuLink from "modules/common/components/MenuLink";

export const SubmenuContent = ({ submenu, ...props }: { submenu: MenuExtendedProps["subMenu"] } & ChakraProps) => (
  <>
    {submenu.map((item: MenuExtendedProps) => (
      <MenuLink menuItem={item} key={item.label} mb={4} display="block" {...props} />
    ))}
  </>
);
